module.exports = __webpack_public_path__ + "static/media/Bonus200.1b12213a.png";